/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The retention of salary.
 */
export enum SalaryRetention {
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}
